interface props {
  title?: string;
  price?: string;
  address?: string;
  imageLink?: string;
  auctionDate?: string;
  bankName?: string;
  bankLogo?: React.ReactNode;
  propertyLink?: string;
  propertyDateType?: string;
  className?: string;
}
export const UpcomingAuctionCard = ({
  title,
  price,
  address,
  imageLink,
  auctionDate,
  bankName,
  bankLogo,
  propertyLink,
  propertyDateType,
  className,
}: props) => {
  return (
    <a
      href={propertyLink}
      target="_"
      className={` bg-white min-w-[281px] min-h-[148px] lg:max-w-[462px] lg:min-h-[153px]  pt-0 mid:py-[10px] pr-[14px] mid:px-[10px] mid:pl-[10px] shadow-lg hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out clip-path-bottomRightUpcomingAuctionCard ${className}`}
    >
      {/* Top part */}
      <div className="flex w-full ">
        <div className="w-[86px] h-[57px] mid:min-h-[61px] mid:min-w-[124px]  clip-path-bottomRightPropertyImage">
          <img className="w-full h-full" src={imageLink} alt="" />
        </div>

        <div className="pl-3 mid:pl-4 w-full pt-[10px] mid:pt-0">
          <div className="flex w-full">
            <p className="font-openSans font-semibold  text-mobile-body-sm  leading-4 text-brand-textBlack mid:font-normal mid:leading-[22px] mid:text-web-body-lg w-[100px] lg:w-full">
              {title}
            </p>
            <p className="font-openSans font-semibold text-mobile-body-sm leading-4  text-brand-textBlack text-nowrap mid:font-semibold mid:leading-[22px] mid:text-web-body-lg ml-auto">
              {propertyDateType === "undated" ? "Contact Us" : `₹ ${price}`}
            </p>
          </div>

          <p className="font-openSans font-normal text-mobile-body-xsm leading-[13px] text-brand-textLightGrey mt-2  mid:text-web-body-sm mid:leading-[18px]  mid:mt-[5px]">
            {address}
          </p>
        </div>
      </div>
      {/* Border */}
      <div className="border-t-[1px] border-[#A8A8A8] opacity-10 mt-3 mid:mt-[26px] mr-[11px]"></div>

      {/* Lower part */}
      <div className="w-[207px] mid:pl-0 pl-[14px] mid:w-full mid:flex mt-0 mid:mt-2">
        <div className="pr-3 items-center flex h-[38px]  bg-gradient-to-r from-white to-[#FEECE6] rounded-tr-lg rounded-br-lg">
          <p className="text-brand-textGrey min-w-max leading-[13px] mid:leading-4 text-mobile-body-xsm mid:text-web-body-sm font-normal font-openSans">
            Auction date
          </p>
          <p className="text-brand-textBlack min-w-max ml-[30px] mid:ml-[18px] text-mobile-body-sm mid:text-web-body-sm font-semibold mid:font-normal font-openSans leading-4 mid:leading-[18px]">
            {propertyDateType === "undated"
              ? "Coming Soon"
              : propertyDateType === "private_treaty"
              ? "Private Treaty"
              : auctionDate}
          </p>
        </div>

        <div className="flex mid:ml-10 items-center gap-x-[9px] mx-auto mid:pr-12 mt-[10px] mid:mt-0">
          <span>{bankLogo}</span>
          <span className="text-brand-textGrey capitalize text-web-body-sm font-normal font-openSans leading-4 ">
            {bankName}
          </span>
        </div>
      </div>
    </a>
  );
};
